import MARY_LABELS from './labels';
import MARY_FEATURES from './features';
import MARY_NAVIGATION from './navigation';

/**
 * Alimentos Mary: the base company. Everything the admin does without a company override is
 * what Mary gets, so this profile only names the company and its backend.
 *
 * This is the light half of the registration (no page components), read by the company
 * registry, the session and the access model. `./index.js` adds the pages.
 */
const MARY = Object.freeze({
    id: 'mary',
    name: 'Alimentos Mary',
    workspaceLabel: 'Alimentos Mary',
    // REACT_APP_API_URL lets a local build talk to a local service (e.g. the test DB stack).
    defaultApiUrl: 'https://service.shelfve.com',
    apiUrlOverride: process.env.REACT_APP_API_URL,
    // User types that may sign in to the admin.
    adminUserTypes: Object.freeze(['admin', 'gerente', 'asesor', 'client', 'TradeMarketing', 'auditAnalyst']),
    // Every user type this backend has (role pickers and filters).
    userTypes: Object.freeze(['gerente', 'asesor', 'promotor', 'auditor', 'analista', 'location', 'admin', 'TradeMarketing', 'auditAnalyst', 'client', 'route']),
    labels: MARY_LABELS,
    features: MARY_FEATURES,
    navigation: MARY_NAVIGATION,
    // Access model: the base defaults in core/access.js.
    access: Object.freeze({}),
    config: Object.freeze({}),
});

export default MARY;
